import { FC } from 'react';
import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';
import { ModalControlModalProps, ModalControlResponse, useModalControl } from '@frontend/design-system';
import { BundleUpgradeModal } from '../components/bundle-upgrade-modal';
import { CallIntelUpgradeDetailsModal } from '../components/feature-upgrade-details-modal/call-intel/CallIntelUpgradeDetailsModal';
import { FormsUpgradeDetailsModal } from '../components/feature-upgrade-details-modal/forms/FormsUpgradeDetailsModal';
import { WivUpgradeDetailsModal } from '../components/feature-upgrade-details-modal/insurance-verification/WivUpgradeDetailsModal';
import { OnlineSchedulingUpgradeDetailsModal } from '../components/feature-upgrade-details-modal/online-scheduling/OnlineSchedulingUpgradeDetailsModal';
import { PracticeAnalyticsUpgradeDetailsModal } from '../components/feature-upgrade-details-modal/practice-analytics/PracticeAnalyticsUpgradeDetailsModal';
import { FeatureUpgradeModalComponentProps } from '../types';

interface UseFeatureUpgradeDetailsModalResults {
  FeatureUpgradeDetailsModal?: FC<FeatureUpgradeModalComponentProps>;
  featureUpgradeDetailsModalControls: ModalControlResponse;
}

const FeatureUpgradeModalMapping: Partial<Record<Feature, FC<FeatureUpgradeModalComponentProps>>> = {
  [Feature.CALL_INTELLIGENCE]: CallIntelUpgradeDetailsModal,
  [Feature.FORMS]: FormsUpgradeDetailsModal,
  [Feature.ONLINE_SCHEDULING]: OnlineSchedulingUpgradeDetailsModal,
  [Feature.PRACTICE_ANALYTICS]: PracticeAnalyticsUpgradeDetailsModal,
  [Feature.WEAVE_VERIFY]: WivUpgradeDetailsModal,
};

interface UseFeatureUpgradeDetailsModalProps {
  feature: Feature;
  isBundleUpgradeEligible?: boolean;
  onClose?: ModalControlModalProps['onClose'];
}
export const useFeatureUpgradeDetailsModal = ({
  feature,
  isBundleUpgradeEligible,
  onClose,
}: UseFeatureUpgradeDetailsModalProps): UseFeatureUpgradeDetailsModalResults => {
  const modalControls = useModalControl({ onClose });
  const FeatureUpgradeDetailsModal = FeatureUpgradeModalMapping[feature];
  return {
    FeatureUpgradeDetailsModal: isBundleUpgradeEligible ? BundleUpgradeModal : FeatureUpgradeDetailsModal,
    featureUpgradeDetailsModalControls: modalControls,
  };
};
